export const SCHEDULED_AGENTS_ROUTE = 'scheduled-agents';

export const AGENT_NOTIFICATIONS_ROUTE = 'agent-notifications';
